import React from 'react';
import { Box, TextField, MenuItem, Typography, Grid } from '@mui/material';

const sexes = [
  { value: '', label: 'Любой' },
  { value: 1, label: 'Женский' },
  { value: 2, label: 'Мужской' },
];

const statuses = [
  { value: '', label: 'Любое' },
  { value: 1, label: 'Не женат/не замужем' },
  { value: 2, label: 'Есть друг/подруга' },
  { value: 3, label: 'Помолвлен/помолвлена' },
  { value: 4, label: 'Женат/замужем' },
  { value: 5, label: 'Всё сложно' },
  { value: 6, label: 'В активном поиске' },
  { value: 7, label: 'Влюблён/влюблена' },
  { value: 8, label: 'В гражданском браке' },
];

const hasPhotoOptions = [
  { value: '', label: 'Любое' },
  { value: '1', label: 'Есть фото' },
  { value: '0', label: 'Нет фото' },
];

function FilterForm({ filters, setFilters, disabled }) {
  const handleChange = e => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>

      {/* Секция: Демография */}
      <Box>
        <Typography variant="subtitle2" color="text.secondary" fontWeight={600} gutterBottom>
          Демография
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select fullWidth label="Пол" name="sex"
              value={filters.sex ?? ''}
              onChange={handleChange}
              disabled={disabled}
            >
              {sexes.map(option => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            <TextField
              fullWidth label="Возраст от" name="age_from" type="number"
              value={filters.age_from || ''}
              onChange={handleChange}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            <TextField
              fullWidth label="Возраст до" name="age_to" type="number"
              value={filters.age_to || ''}
              onChange={handleChange}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <TextField
              select fullWidth label="Семейное положение" name="status"
              value={filters.status ?? ''}
              onChange={handleChange}
              disabled={disabled}
            >
              {statuses.map(option => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth label="Город" name="city" type="text"
              placeholder="Москва"
              value={filters.city || ''}
              onChange={handleChange}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth label="Страна" name="country" type="text"
              placeholder="Россия"
              value={filters.country || ''}
              onChange={handleChange}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Секция: Активность и профиль */}
      <Box>
        <Typography variant="subtitle2" color="text.secondary" fontWeight={600} gutterBottom>
          Активность и профиль
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3} md={2}>
            <TextField
              fullWidth label="Подписчики от" name="followers_min" type="number"
              value={filters.followers_min || ''}
              onChange={handleChange}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            <TextField
              fullWidth label="Подписчики до" name="followers_max" type="number"
              value={filters.followers_max || ''}
              onChange={handleChange}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              fullWidth label="Активен (дней)" name="last_seen_days" type="number"
              value={filters.last_seen_days || ''}
              onChange={handleChange}
              disabled={disabled}
              helperText="Онлайн за N дней"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              select fullWidth label="Фото" name="has_photo"
              value={filters.has_photo !== undefined ? filters.has_photo : ''}
              onChange={handleChange}
              disabled={disabled}
            >
              {hasPhotoOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Box>

    </Box>
  );
}

export default FilterForm;
